const CryptoJS = require('crypto-js');

// 비밀번호를 암호화하는 함수
export const encryptPassword = (password: string, solt: string = process.env.SOLT_KEY!): string => {
  // AES 암호화를 사용하여 비밀번호를 암호화합니다. 비밀 키는 'secret-key'입니다.
  const encryptedPassword: string = CryptoJS.AES.encrypt(password, solt).toString();
  return encryptedPassword;
};

// 암호화된 비밀번호를 복호화하는 함수
export const decryptPassword = (encryptedPassword: string, solt: string = process.env.SOLT_KEY!): string => {
  // AES 복호화를 사용하여 암호화된 비밀번호를 복호화합니다. 비밀 키는 'secret-key'입니다.
  const bytes = CryptoJS.AES.decrypt(encryptedPassword, solt);
  const decryptedPassword: string = bytes.toString(CryptoJS.enc.Utf8);
  return decryptedPassword;
};
